module.exports = __webpack_public_path__ + "b3111b58e8906be9778d1287d1ecb4b0.png";